import { Capacitor } from '@capacitor/core'

/**
 * Check if running as native app
 */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform()

/**
 * Get current platform (web, ios, android)
 */
export const getPlatform = (): string => Capacitor.getPlatform()

export const getOrCreateDeviceId = (): string => {
    if (typeof localStorage === 'undefined') return 'web-device'
    const existing = localStorage.getItem('device_id')
    if (existing) return existing

    const newId = (typeof crypto !== 'undefined' && 'randomUUID' in crypto)
        ? (crypto as any).randomUUID()
        : 'dev-' + Math.random().toString(36).substring(2) + Date.now().toString(36)

    localStorage.setItem('device_id', newId)
    return newId
}
